import React from "react";
import IntlMessages from "util/IntlMessages";

const PartnerPerformance = () => {
  return (
    <div>
      <h1 className="title gx-mb-4">
        <IntlMessages id="sidebar.partnerList" />
      </h1>
    </div>
  );
};

export default PartnerPerformance;
